<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-12-12 13:45:19
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-12-20 10:20:04
 * @FilePath: /wemeet-admin-new/src/views/enterPriseConfig/index.vue
 * @Description:
 * Copyright (c) 2024 by WeMeet, All Rights Reserved.
-->
<template>
  <div>
    <vab-query-form style="padding-top: 20px">
      <vab-query-form-left-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item v-if="customInfo.tenantKey == 'WeMeet'" label="入驻平台来源">
            <el-select v-model="queryForm.queryEventKey" class="m-2" clearable placeholder="请选择入驻平台来源"
              @change="queryData">
              <el-option v-for="item in tenantOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="机构名称">
            <el-input v-model="queryForm.likeEnterprise" clearable placeholder="请输入机构名称" @change="queryData"
              @clear="queryData" />
          </el-form-item>
          <el-form-item label="负责人手机号">
            <el-input v-model="queryForm.likePhone" clearable placeholder="请输入负责人手机号" @change="queryData"
              @clear="queryData" />
          </el-form-item>
          <el-form-item label="负责人姓名">
            <el-input v-model="queryForm.likeName" clearable placeholder="请输入负责人姓名" @change="queryData"
              @clear="queryData" />
          </el-form-item>
          <el-form-item label="机构会员版本">
            <el-select v-model="queryForm.member" class="m-2" clearable placeholder="请选择机构类型" @change="queryData">
              <el-option v-for="(item, index) in typeOptions" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item label="审核状态">
            <el-select v-model="queryForm.status" class="m-2" clearable placeholder="请选择状态" @change="queryData">
              <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item label="入驻时间">
            <el-date-picker v-model="createTime" end-placeholder="结束时间" :shortcuts="shortcuts" start-placeholder="开始时间"
              type="daterange" value-format="YYYY-MM-DD" />
          </el-form-item>
          <el-form-item label="会员到期时间">
            <el-date-picker v-model="memberTime" end-placeholder="结束时间" :shortcuts="shortcuts" start-placeholder="开始时间"
              type="daterange" value-format="YYYY-MM-DD" />
          </el-form-item>

          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
            <el-button :icon="Delete" type="warning" @click="resetQueryData">置空</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-left-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list" :table-layout="'auto'">
      <el-table-column align="center" label="序号" type="index" width="50px" />
      <el-table-column label="机构名称" prop="enterpriseName" />
      <el-table-column label="机构负责人姓名" prop="name" />
      <el-table-column label="负责人手机号" prop="phone" />
      <el-table-column label="机构会员版本" prop="member">
        <template #default="{ row }">
          {{ handleMember(row) }}
        </template>
      </el-table-column>
      <el-table-column label="入驻时间" prop="createTime" />
      <el-table-column label="会员到期时间" prop="memberExpireTime" />
      <!-- <el-table-column label="交易类型" prop="createTime">
        <template #default="{ row }">
          {{ handlePayType(row) }}
        </template>
      </el-table-column>
      <el-table-column label="交易明细">
        <template #default="{ row }">
          <span v-if="row.payType == 'WECHAT_PAY' && row.status == 'PAY_OVER'">
            {{ row.outOrderNo }}
          </span>
          <el-button plain v-if="
              (row.payType == 'NON_PROFIT_ORG' ||
                row.payType == 'CORPORATE_TRANSFER') &&
              row.status == 'PAY_OVER'
            " @click="handleEdit(row, 'SEE')" type="primary">
            {{
              row.payType == 'NON_PROFIT_ORG' ? '查看证明材料' : '查看支付凭证'
            }}
          </el-button>
          <span v-if="row.status != 'PAY_OVER'">/</span>
        </template>
      </el-table-column>
      <el-table-column label="下单人手机号" prop="phone" />
      <el-table-column label="支付状态" prop="createTime">
        <template #default="{ row }">
          {{ handlePayStatus(row) }}
        </template>
      </el-table-column> -->
      <el-table-column label="审核状态" prop="status">
        <template #default="{ row }">
          {{ handleAuditStatus(row) }}
        </template>
      </el-table-column>

      <el-table-column v-if="customInfo.tenantKey == 'WeMeet'" label="入驻平台来源" prop="eventKey" />
      <!-- <el-table-column label="提交时间" prop="orderTime">
        <template #default="{ row }">
          {{ handleDate(row.orderTime) }}
        </template>
      </el-table-column> -->

      <!-- <el-table-column label="订单状态" prop="reason" show-overflow-tooltip>
        <template #default="{ row }">
          <span v-if="row.status == 'REJECTED'">{{ row.reason }}</span>
        </template>
      </el-table-column> -->

      <el-table-column label="操作" width="250px">
        <template #default="{ row }">
          <el-button plain type="primary" @click="handleEdit(row, 'SEE')">查看</el-button>
          <el-button plain type="info" @click="handleGoOrder(row)">订单</el-button>
          <el-button v-if="customInfo.tenantKey === row.eventKey" plain type="success"
            @click="handleEdit(row, 'AUDIT')">
            审核
          </el-button>
          <!-- <el-button type="success" plain @click="handleEdit(row, 'manage')">
            管理
          </el-button> -->
        </template>
      </el-table-column>
      <template #empty>
        <!-- <el-image
                class="vab-data-empty"
                :src="require('@/assets/empty_images/data_empty.png')"
              /> -->
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination background :current-page="queryForm.pageNumber" :layout="layout" :page-size="queryForm.pageSize"
      :total="total" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
    <edit ref="editRef" @fetch-data="fetchData" />
  </div>
</template>

<script>
import {
  defineComponent,
  defineAsyncComponent,
  getCurrentInstance,
  onMounted,
  reactive,
  toRefs,
  onActivated,
  computed,
} from 'vue'

import { Delete, Plus, Search } from '@element-plus/icons'
import {
  getAllEnterPriseListByOrg,
  delEnterPrise,
} from '@/api/enterPriseApi'
import { parseTime } from '@/utils/index'
import { useStore } from 'vuex'
import useTenants from '@/hooks/useTenants'

export default defineComponent({
  name: 'EnterpriseManage',
  components: {
    Edit: defineAsyncComponent(() => import('./components/edit')),
  },
  setup() {
    const { proxy } = getCurrentInstance()

    const store = useStore()
    const { getTenantOptions, getTenantNameByKey } = useTenants()

    const state = reactive({
      queryForm: {
        createEndTime: '',
        createStartTime: '',
        enterpriseTypeId: '',
        likeEnterprise: '',
        likeName: '',
        likePhone: '',
        member: '',
        pageNum: 1,
        pageSize: 20,
        status: '',
        memberEndTime: '',
        memberStartTime: '',
        queryEventKey: '',
      },
      tenantOptions: getTenantOptions('eventKey'),
      createTime: [],
      memberTime: [],
      shortcuts: [
        {
          text: '上周',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setDate(start.getDate() - 7)
            return [start, end]
          },
        },
        {
          text: '上月',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 1)
            return [start, end]
          },
        },
        {
          text: '最近三个月',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 3)
            return [start, end]
          },
        },
      ],
      total: 0,
      shopList: [],
      listLoading: false,
      list: [],
      layout: 'prev, pager, next',
      editRef: null,
      typeOptions: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '标准机构会员',
          value: 'BASE',
        },
        // {
        //   label: '中级机构会员',
        //   value: 'INTERMEDIATE_VIP',
        // },
        {
          label: 'VIP 机构会员',
          value: 'VIP',
        },
        {
          label: '赠送',
          value: 'VIP_TRY',
        },
      ],
      payTypeOption: [
        {
          label: '微信支付',
          value: 'WECHAT_PAY',
        },
        {
          label: '非盈利机构',
          value: 'NON_PROFIT_ORG',
        },
        {
          label: '对公转账',
          value: 'CORPORATE_TRANSFER',
        },
        {
          label: '赠送',
          value: 'DONATION',
        },
      ],
      payStatusOption: [
        {
          label: '待支付',
          value: 'PAY_WAIT',
          type: 'success',
        },
        {
          label: '部分支付',
          value: 'PAY_PART',
          type: 'success',
        },

        {
          label: '已支付',
          value: 'PAY_OVER',
          type: 'success',
        },
        {
          label: '支付完待确认',
          value: 'PAY_CONFIRMED',
          type: 'success',
        },
        {
          label: '支付不通过',
          value: 'PAY_NOT_PASS',
          type: 'success',
        },
      ],
      statusOption: [
        {
          label: '全部',
          value: '',
          type: 'success',
        },
        {
          label: '审核通过',
          value: 'AUDIT_APPROVED',
          type: 'success',
        },
        {
          label: '待审核',
          value: 'PENDING_AUDIT',
        },
        {
          label: '不通过',
          value: 'REJECTED',
          type: 'danger',
        },
      ],
    })

    const handleEdit = (row, type) => {
      row.formStatus = type
      state.editRef.showEdit(row)
    }

    const handleDelete = (row) => {
      if (row.enterpriseCode) {
        proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
          const { msg } = await delEnterPrise({
            enterpriseCode: row.enterpriseCode,
          })
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          await fetchData()
        })
      }
    }

    const queryData = () => {
      console.log(state.createTime)
      if (state.createTime && state.createTime.length > 0) {
        console.log(state.createTime)
        state.queryForm.createStartTime = parseTime(state.createTime[0], '{y}-{m}-{d}')
        state.queryForm.createEndTime = parseTime(state.createTime[1], '{y}-{m}-{d}')
      } else {
        state.queryForm.createStartTime = ''
        state.queryForm.createEndTime = ''
      }
      if (state.memberTime && state.memberTime.length > 0) {
        state.queryForm.memberStartTime = parseTime(state.memberTime[0], '{y}-{m}-{d}')
        state.queryForm.memberEndTime = parseTime(state.memberTime[1], '{y}-{m}-{d}')
      } else {
        state.queryForm.memberStartTime = ''
        state.queryForm.memberEndTime = ''
      }
      fetchData()
    }

    const resetQueryData = () => {
      state.queryForm = {
        createEndTime: '',
        createStartTime: '',
        enterpriseTypeId: '',
        likeEnterprise: '',
        likeName: '',
        likePhone: '',
        member: '',
        pageNum: 1,
        pageSize: 20,
        status: '',
        memberEndTime: '',
        memberStartTime: '',
      }
      state.createTime = []
      state.memberTime = []
      fetchData()
    }

    const fetchData = async () => {
      state.listLoading = true

      // const { data: typeList } = await getAllEnterPriseTypeList()
      const { data } = await getAllEnterPriseListByOrg(state.queryForm)
      console.log(data, '1123123')
      // data.list.forEach((item) => {
      //   item.eventKey = getTenantNameByKey('eventKey', item.eventKey)
      // })
      state.list = data.list
      state.total = data.total
      // console.log(typeList)
      // state.typeOptions = typeList
      state.listLoading = false
    }

    const handleSizeChange = (val) => {
      state.queryForm.pageSize = val
      queryData()
    }
    const handleCurrentChange = (val) => {
      state.queryForm.pageNum = val
      queryData()
    }

    onMounted(() => {
      const customInfo = store.getters['user/customInfo']
      if (customInfo.tenantKey !== 'WeMeet') {
        state.queryForm.queryEventKey = customInfo.tenantKey
      }
      queryData()
    })

    const handlePayDetail = (row) => {
      let checkItem = state.payTypeOption.filter((v) => v.value == row.payType)
      // 微信支付且已支付
      if (row.status == 'PAY_OVER' && row.payType == 'WECHAT_PAY') {
        return checkItem[0].outOrderNo
      }
    }

    const handlePayStatus = (row) => {
      return row.status == 'PAY_WAIT'
        ? '待支付'
        : row.status == 'PAY_OVER'
          ? '已支付'
          : row.status == 'PAY_CONFIRMED'
            ? '支付待确认'
            : row.status == 'PAY_NOT_PASS'
              ? '支付被驳回'
              : '支付取消'
    }

    const handleMember = (row) => {
      console.log()
      let memberItem = state.typeOptions.filter((v) => v.value == row.member)
      if (memberItem.length > 0) {
        return memberItem[0].label
      } else {
        return '/'
      }
    }

    const handleAuditStatus = (row) => {
      return row.status == 'PENDING_AUDIT'
        ? '待审核'
        : row.status == 'TRIAL'
          ? '试用'
          : row.status == 'AUDIT_APPROVED'
            ? '审核通过'
            : '审核驳回'
    }

    const handlePayType = (row) => {
      let checkItem = state.payTypeOption.filter((v) => v.value == row.payType)
      if (checkItem.length > 0) {
        return checkItem[0].label
      } else {
        return '暂无数据'
      }
    }

    const handleDate = (date) => {
      return parseTime(date)
    }

    const handleGoOrder = (row) => {
      proxy.$router.push({
        path: '/enterPriseConfig/enterpriseOrder',
        query: {
          enterpriseName: row.enterpriseName,
        },
      })
    }

    return {
      ...toRefs(state),
      handleEdit,
      queryData,
      fetchData,
      handleSizeChange,
      handleCurrentChange,
      handleDelete,
      Delete,
      Search,
      Plus,
      resetQueryData,
      handlePayType,
      handlePayDetail,
      handlePayStatus,
      handleAuditStatus,
      handleDate,
      handleGoOrder,
      handleMember,
      getTenantNameByKey,
      customInfo: computed(() => store.getters['user/customInfo']),
    }
  },
})
</script>
<style lang="scss" scoped></style>
